import { useQuery } from '@tanstack/react-query'

import { shareVerificationLink } from '../functions/shareVerificationLink'

function useShareOtpVerificationLink({ onSuccess, customerId }) {
  return useQuery(
    ['shareVerificationLink'],
    () => shareVerificationLink(customerId),
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      refetchInterval: 0,
      onSuccess: onSuccess,
    }
  )
}
export { useShareOtpVerificationLink }
